<template>
  <div>

    <hr class="hit-html-hr" v-bind:style="{'border-color': survey.colors.accent_color}">
    
    <div class="hit-form-group">
      <label for="validation" class="hit-html-label"> {{ $t("message.validation") }}</label>

      <!-- <hit_toggle :data="get_toggle()" :value="'email'" :callback="function(data){ settings.validation_method = data; r.validation = data; }"/> -->

      <small v-if="settings.validation_method == 'email'" class="hit-html-small"><hit_icon :id="'ok'" /> {{ $t("message.getValidationEmail") }}</small>
      <small v-if="settings.validation_method == 'handy'" class="hit-html-small"><hit_icon :id="'ok'" /> {{ $t("message.getValidationSMS") }}</small>

    </div>

    <div class="hit-form-group">
      <h5 class="hit-html-h5">{{ $t("message.personalData") }}</h5>
    </div>

    <div class="hit-form-group">
      <label for="name" class="hit-html-label">{{ $t("message.first_name") }} {{ $t("message.last_name") }}</label>
      <div class="hit-input-group">
        <div class="hit-input-group-addon" v-bind:style="{'border-color': survey.colors.accent_color, 'background': survey.colors.accent_color, 'color': survey.colors.accent_color2}"><hit_icon :id="'user'" />
        </div>
        <div class="hit-input-group-btn">
          <div class="hit-btn hit-btn-danger" v-if="error.name === true"><hit_icon :id="'remove'" /></div>
          <div class="hit-btn hit-btn-success" v-if="error.name !== true"><hit_icon :id="'ok'" /></div>
        </div>
        <input id="name" spellcheck="false" v-bind:style="{'background': survey.colors.background_color, 'color': survey.colors.text_color, 'border-color': survey.colors.accent_color}" type="text" class="hit-form-control"
        v-bind:placeholder='$t("message.add", {name: $t("message.first_name")+" "+$t("message.last_name")})'  v-model="r.name">

    </div>
    </div>

    <div class="hit-form-group" v-if="settings.validation_method == 'email'">
      <label for="email" class="hit-html-label">{{ $t("message.email") }}</label>
    <div class="hit-input-group">
      <div class="hit-input-group-addon " v-bind:style="{'border-color': survey.colors.accent_color, 'background': survey.colors.accent_color, 'color': survey.colors.accent_color2}"><hit_icon :id="'envelope'" />
      </div>
      <div class="hit-input-group-btn">
        <div class="hit-btn hit-btn-danger" v-if="error.email === true"><hit_icon :id="'remove'" /></div>
        <div class="hit-btn hit-btn-success" v-if="error.email !== true"><hit_icon :id="'ok'" /></div>
      </div>
      <input v-bind:placeholder='$t("message.add", {name: $t("message.email")})' id="email" spellcheck="false" v-bind:style="{'background': survey.colors.background_color, 'color': survey.colors.text_color, 'border-color': survey.colors.accent_color}" type="text" class="hit-form-control" v-model="r.email">

    </div>
    </div>

    <div class="hit-form-group" v-if="settings.validation_method == 'handy'">
      <label for="handy" class="hit-html-label">{{ $t("message.mobileNumber") }}</label>
    <div class="hit-input-group" >
      <div class="hit-input-group-addon" v-bind:style="{'border-color': survey.colors.accent_color, 'background': survey.colors.accent_color, 'color': survey.colors.accent_color2}"><hit_icon :id="'iphone'" />
      </div>
      <div class="hit-input-group-btn">
        <div class="hit-btn hit-btn-danger" v-if="error.handy === true"><hit_icon :id="'remove'" /></div>
        <div class="hit-btn hit-btn-success" v-if="error.handy !== true"><hit_icon :id="'ok'" /></div>
      </div>
      <input id="handy" v-bind:placeholder='$t("message.add", {name: $t("message.mobileNumber")})' spellcheck="false"  v-bind:style="{'background': survey.colors.accent_color2, 'color': survey.colors.accent_color, 'border-color': survey.colors.accent_color}" type="text" class="hit-form-control" v-model="r.handy">

    </div>
    </div>

  </div>
</template>
<script>
export default {
  components: {},
  props: { error: Object, survey: Object, r: Object, settings: Object },
  mounted () {

  },
  computed: {

  },
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>
<style lang="sass" scoped>
</style>
